/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Application_Commands_AddUser_AddUserRequest } from '../models/BigClock_Application_Commands_AddUser_AddUserRequest';
import type { BigClock_Application_Queries_Authenticate_AuthenticateRequest } from '../models/BigClock_Application_Queries_Authenticate_AuthenticateRequest';
import type { BigClock_Application_Queries_GetUser_GetUserResponse } from '../models/BigClock_Application_Queries_GetUser_GetUserResponse';
import type { BigClock_Application_Queries_GetUsers_GetUsersResponse } from '../models/BigClock_Application_Queries_GetUsers_GetUsersResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiUsersAuthenticate(
        requestBody?: BigClock_Application_Queries_Authenticate_AuthenticateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Users/authenticate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns BigClock_Application_Queries_GetUsers_GetUsersResponse Success
     * @throws ApiError
     */
    public static getApiUsers(): CancelablePromise<BigClock_Application_Queries_GetUsers_GetUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiUsers(
        requestBody?: BigClock_Application_Commands_AddUser_AddUserRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetUser_GetUserResponse Success
     * @throws ApiError
     */
    public static getApiUsers1(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetUser_GetUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiUsers(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Users/{id}',
            path: {
                'id': id,
            },
        });
    }
}
